import { TemplateSummary } from '@/components/dashboard/TemplateSummary';
import { AppShell } from '@/components/layout/AppShell';
import { DataStatePanel } from '@/components/shared/DataStatePanel';
import { PageHeader } from '@/components/shared/PageHeader';
import { useAuth } from '@/hooks/useAuth';
import { useGuildData } from '@/hooks/useGuildData';

export function TemplatesPage(): JSX.Element {
  const { state, dashboardSnapshot, isLoading, error, refreshData } = useGuildData();
  const { hasAnyRole } = useAuth();

  return (
    <AppShell>
      <PageHeader
        title="Mass Templates"
        description="Saved layouts and working drafts."
      />

      {isLoading ? <DataStatePanel title="Loading templates" description="Fetching saved templates and any working drafts linked to your account." /> : null}
      {!isLoading && error ? (
        <DataStatePanel title="Unable to load templates" description={error} actionLabel="Retry" onAction={() => void refreshData()} />
      ) : null}

      {!isLoading && !error ? (
        <TemplateSummary
          templates={dashboardSnapshot.templates}
          templateDrafts={state.templateDrafts}
          templateSlots={dashboardSnapshot.templateSlots}
          canManageTemplates={hasAnyRole(['admin', 'officer'])}
        />
      ) : null}
    </AppShell>
  );
}
